export default __webpack_public_path__ + "static/media/bgdt.3b0974d0.jpg";